import React from "react";

/**
 * PageHeader — consistent title/subtitle/actions row used at the top of
 * every admin page, now that AdminShell (not each page) owns the sidebar
 * and background.
 */
const PageHeader = ({ title, subtitle, actions }) => (
  <div className="flex items-start justify-between gap-4 flex-wrap">
    <div>
      <h1 className="text-2xl font-display font-bold text-celestial-text">{title}</h1>
      {subtitle && <p className="text-sm text-celestial-muted mt-1 max-w-2xl">{subtitle}</p>}
    </div>
    {actions && <div className="flex items-center gap-2 flex-wrap shrink-0">{actions}</div>}
  </div>
);

export default PageHeader;
